import ExternalLink from "components/ExternalLink";
import './avoriazSocialLinks.scss';

const AvoriazSocialLinks = () => {
  return <div className="avoriaz-social-links-container">
    <ExternalLink />
  </div>
}

export default AvoriazSocialLinks;